// @ts-strict-ignore
import React from 'react';
import { Typography } from 'onboarding-components';
import { SvgIconReact } from 'common/components/svg-icon';
import { openDemoProjectSelectorModal } from 'common/widgets/demo-selector-modal';
import { ToastType } from 'common/components/toast/types';
import { track, TrackingEvent, TrackingProperty } from 'common/onboarding/immersive-onboarding-legacy/tracking';
import { addToast } from 'common/components/toast-area/toast-manager';
import { openMediaModal } from 'common/widgets/tutorial-video-modal';
import { VisibilityContext } from 'common/onboarding/immersive-onboarding-legacy/types';
import { Permission } from 'common/report/constants';
import type { ChromeHeader } from 'common/widgets/chrome/chrome-header';
import { LEARN_MIXPANEL_YT_URL } from 'common/onboarding/immersive-onboarding-legacy/constants';
import { useCurrentUser } from 'common/contexts/react/current-user-context';
import { useCurrentProject } from 'common/contexts/react/current-project-context';
import { useTranslation } from 'common/i18n/hooks';
import { useGlobalSidenavController } from 'common/contexts/react/global-sidenav-controller-context';
import { isGlobalSidenavEnabled } from 'iron/routes/global-sidenav/utils';
import styles from './footer-action-bar.module.styl';
export const FooterActionBar: React.FC = () => {
  var _currentUser$organiza;
  const {
    t
  } = useTranslation();
  const {
    setVisibility
  } = React.useContext(VisibilityContext);
  const currentUser = useCurrentUser().get().value;
  const currentProject = useCurrentProject().get().value;
  const globalSidenavController = useGlobalSidenavController();
  const {
    organizationId
  } = currentProject !== null && currentProject !== void 0 ? currentProject : {};
  const canInviteUsers = currentUser === null || currentUser === void 0 || (_currentUser$organiza = currentUser.organizations) === null || _currentUser$organiza === void 0 || (_currentUser$organiza = _currentUser$organiza[organizationId]) === null || _currentUser$organiza === void 0 ? void 0 : _currentUser$organiza.permissions.includes(Permission.AddUser);
  return <div className={styles.footerContainer} data-sentry-component="FooterActionBar" data-sentry-source-file="footer-action-bar.tsx">
      <Typography className={styles.footerContainerTitle} variant='headingXs' data-sentry-element="Typography" data-sentry-source-file="footer-action-bar.tsx">
        {t("onboarding-legacy.welcome.not-ready")}
      </Typography>
      <div className={styles.footerActionBar}>
        <div className={styles.cta} onClick={() => {
        openDemoProjectSelectorModal(ev => {
          addToast({
            message: ev.detail.message,
            type: ToastType.ERROR
          });
        }, {
          'is-new-tab': true
        });
        track(TrackingEvent.WelcomeResourceClick, {
          [TrackingProperty.Name]: "demo project"
        });
      }}>
          <SvgIconReact icon='line' data-sentry-element="SvgIconReact" data-sentry-source-file="footer-action-bar.tsx" />
          {t("onboarding-legacy.welcome.view-demo-project")}
        </div>
        <div className={styles.cta} onClick={() => {
        openMediaModal(ev => {
          if (ev.type === "error") {
            addToast({
              message: ev.detail.message,
              type: ToastType.ERROR
            });
          }
        }, {
          'custom-url': LEARN_MIXPANEL_YT_URL,
          title: t("onboarding.welcome.how-analytics-help"),
          width: 1024,
          height: 567
        });
        track(TrackingEvent.WelcomeResourceClick, {
          [TrackingProperty.Name]: "video"
        });
      }}>
          <SvgIconReact icon='brand-help' data-sentry-element="SvgIconReact" data-sentry-source-file="footer-action-bar.tsx" />
          {t("onboarding-legacy.welcome.how-mixpanel-works")}
        </div>
        <div className={styles.cta} onClick={() => {
        if (canInviteUsers) {
          setVisibility(false);
          if (isGlobalSidenavEnabled(currentProject)) {
            globalSidenavController.openInviteUserModal({
              closeCallback: () => setVisibility(true)
            });
          } else {
            const chromeHeader = document.querySelector<ChromeHeader>("mp-chrome-header");
            chromeHeader.helpers.openInviteUserModal(() => setVisibility(true));
          }
        } else {
          addToast({
            type: ToastType.ERROR,
            message: t("onboarding.welcome.no-invite-permission")
          });
        }
        track(TrackingEvent.InviteTeammate);
      }}>
          <SvgIconReact icon='plus' data-sentry-element="SvgIconReact" data-sentry-source-file="footer-action-bar.tsx" />
          {t("onboarding-legacy.welcome.invite-teammate")}
        </div>
      </div>
    </div>;
};